// src/pages/PlatformSettingsPage.jsx
// C3.2.9.5 — Configuración de Plataforma estilo Lead Web ORBIS
import React, { useEffect, useMemo, useState } from "react";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";



function authHeaders(extra = {}) {
    const token = localStorage.getItem("cani_auth") || "";
    return {
        ...extra,
        Authorization: `Bearer ${token}`,
        "X-CANI-AUTH": token,
    };
}

async function safeJson(url, options = {}) {
    const res = await fetch(url, options);
    const text = await res.text();
    let data;
    try {
        data = JSON.parse(text);
    } catch {
        throw new Error(`Respuesta no JSON HTTP ${res.status}: ${text.slice(0, 180)}`);
    }
    if (!res.ok || data.ok === false || data.success === false) {
        throw new Error(data.error || data.detail || `HTTP ${res.status}`);
    }
    return data;
}

function Field({ label, children, hint }) {
    return (
        <label className="flex flex-col gap-1 text-xs">
            <span className="font-semibold text-[#8fb9da] uppercase tracking-[0.12em] text-[11px]">{label}</span>
            {children}
            {hint ? <span className="text-[10px] text-[#9fc4df]">{hint}</span> : null}
        </label>
    );
}

function Card({ title, subtitle, right, children }) {
    return (
        <div className="platform-card rounded-[24px] overflow-hidden">
            <div className="platform-card-head px-5 py-4 flex items-start justify-between gap-3">
                <div>
                    <h3 className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#d4af37]">{title}</h3>
                    {subtitle ? <p className="text-[11px] text-[#9fc4df] mt-1">{subtitle}</p> : null}
                </div>
                {right}
            </div>
            <div className="p-5">{children}</div>
        </div>
    );
}

function Style() {
    return (
        <style>{`
            .platform-settings-pro{
                min-height:100vh;
                background:#041426;
                color:#f5fbff;
            }

            .platform-settings-wrap{
                max-width:1500px;
                margin:0 auto;
                display:flex;
                flex-direction:column;
                gap:24px;
            }

            .platform-hero{
                background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%);
                border:1px solid rgba(11,93,140,.8);
                box-shadow:0 20px 45px rgba(0,0,0,.28);
                border-radius:28px;
                padding:28px;
                display:flex;
                align-items:flex-start;
                justify-content:space-between;
                gap:20px;
            }

            .platform-eyebrow{
                display:inline-flex;
                align-items:center;
                gap:12px;
                color:#d4af37;
                text-transform:uppercase;
                letter-spacing:.24em;
                font-size:12px;
                font-weight:800;
                margin-bottom:12px;
            }

            .platform-eyebrow::before{
                content:"";
                width:40px;
                height:1px;
                background:#d4af37;
                display:inline-block;
            }

            .platform-title{
                font-size:36px;
                line-height:1.05;
                font-weight:900;
                color:#fff;
                margin:0;
                letter-spacing:-.03em;
            }

            .platform-subtitle{
                margin-top:12px;
                color:#d7e8f6;
                font-size:14px;
                line-height:1.65;
                max-width:860px;
            }

            .platform-card{
                border:1px solid rgba(11,93,140,.82);
                background:#04192b;
                color:#f5fbff;
                box-shadow:0 12px 30px rgba(0,0,0,.24);
            }

            .platform-card-head{
                background:#031425;
                border-bottom:1px solid #0b4d78;
            }

            .platform-tabs{
                background:#04192b;
                border:1px solid #0b4d78;
                box-shadow:0 12px 30px rgba(0,0,0,.22);
                border-radius:24px;
                padding:8px;
                display:flex;
                flex-wrap:wrap;
                gap:8px;
            }

            .platform-tab{
                border:1px solid #24537a;
                background:#0b2740;
                color:#f5fbff;
                border-radius:999px;
                padding:9px 14px;
                font-size:12px;
                font-weight:700;
                transition:background .18s ease,border-color .18s ease,color .18s ease;
            }

            .platform-tab:hover{
                background:#10324f;
                border-color:#d4af37;
            }

            .platform-tab-active{
                background:#d4af37;
                color:#081a2b;
                border-color:#d4af37;
            }

            .platform-btn{
                border:1px solid #24537a;
                background:#0b2740;
                color:#f5fbff;
                border-radius:999px;
                padding:10px 14px;
                font-size:12px;
                font-weight:700;
            }

            .platform-btn:hover{
                background:#10324f;
                border-color:#d4af37;
            }

            .platform-btn-primary{
                background:#d4af37;
                color:#081a2b;
                border-color:#d4af37;
                font-weight:800;
            }

            .platform-btn-primary:hover{
                background:#e8c457;
            }

            .platform-settings-pro input,
            .platform-settings-pro select,
            .platform-settings-pro textarea{
                border:1px solid #0b5f91;
                border-radius:12px;
                padding:10px 12px;
                font-size:12px;
                outline:none;
                background:#0b2740;
                color:#fff;
            }

            .platform-settings-pro input::placeholder,
            .platform-settings-pro textarea::placeholder{
                color:#7ea8c7;
            }

            .platform-settings-pro input:focus,
            .platform-settings-pro textarea:focus,
            .platform-settings-pro select:focus{
                border-color:#d4af37;
                box-shadow:0 0 0 2px rgba(212,175,55,.18);
            }

            .platform-settings-pro select option{
                background:#061a2f;
                color:#fff;
            }

            .platform-settings-pro input[type="color"]{
                width:72px;
                height:38px;
                padding:4px;
                cursor:pointer;
            }

            .platform-upload-box{
                border:1px solid #0b4d78;
                background:#08233d;
                border-radius:18px;
                padding:16px;
                transition:background .18s ease,border-color .18s ease;
            }

            .platform-upload-box:hover{
                background:#0b2740;
                border-color:#d4af37;
            }

            .platform-upload-preview{
                border:1px solid #24537a;
                background:#0b2740;
                border-radius:14px;
                object-fit:contain;
                padding:6px;
            }

            .platform-avatar-box{
                border:1px solid #0b4d78;
                background:#08233d;
                border-radius:22px;
                padding:18px;
                text-align:center;
            }

            .platform-avatar{
                border:2px solid #0b5f91;
                background:#0b2740;
            }

            .platform-preview{
                border:1px solid #0b4d78;
                background:#08233d;
                color:#f5fbff;
                box-shadow:inset 0 5px 0 var(--preview-color, #d4af37);
            }

            .platform-toast-ok{
                background:#0a332e;
                color:#86efac;
                border:1px solid rgba(16,185,129,.4);
            }

            .platform-toast-error{
                background:#2b1117;
                color:#fca5a5;
                border:1px solid rgba(239,68,68,.4);
            }

            .platform-settings-pro ::-webkit-scrollbar{height:10px;width:10px}
            .platform-settings-pro ::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
            .platform-settings-pro ::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
            .platform-settings-pro ::-webkit-scrollbar-thumb:hover{background:#d4af37}

            @media(max-width:768px){
                .platform-hero{padding:20px;flex-direction:column}
                .platform-title{font-size:30px}
            }
        `}</style>
    );
}

export default function PlatformSettingsPage() {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [uploading, setUploading] = useState("");
    const [settings, setSettings] = useState({});
    const [profile, setProfile] = useState({});
    const [tab, setTab] = useState("general");
    const [toast, setToast] = useState(null);

    const values = useMemo(() => {
        const out = {};
        Object.entries(settings || {}).forEach(([key, row]) => {
            out[key] = row?.setting_value ?? "";
        });
        return out;
    }, [settings]);

    async function load() {
        try {
            setLoading(true);
            setToast(null);
            const data = await safeJson(`${API_BASE}/platform_settings_get.php`, {
                headers: authHeaders(),
            });
            setSettings(data.settings || {});
            setProfile(data.user || {});
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { load(); }, []);

    function setValue(key, value) {
        setSettings((prev) => ({
            ...prev,
            [key]: {
                ...(prev[key] || {}),
                setting_key: key,
                setting_value: value,
            },
        }));
    }

    async function saveSettings() {
        try {
            setSaving(true);
            setToast(null);

            const payload = {};
            [
                "platform_name",
                "platform_short_name",
                "commercial_name",
                "domain",
                "public_domain",
                "support_email",
                "support_phone",
                "meta_description",
                "primary_color",
                "secondary_color",
                "accent_color",
            ].forEach((key) => {
                payload[key] = values[key] || "";
            });

            await safeJson(`${API_BASE}/platform_settings_update.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({ settings: payload }),
            });

            setToast({ type: "ok", msg: "Configuración guardada." });
            await load();
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setSaving(false);
        }
    }

    async function uploadAsset(key, file) {
        if (!file) return;
        try {
            setUploading(key);
            setToast(null);
            const fd = new FormData();
            fd.append("setting_key", key);
            fd.append("file", file);

            await safeJson(`${API_BASE}/platform_settings_upload_asset.php`, {
                method: "POST",
                headers: authHeaders(),
                body: fd,
            });

            setToast({ type: "ok", msg: "Asset actualizado." });
            await load();
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setUploading("");
        }
    }

    async function saveProfile() {
        try {
            setSaving(true);
            setToast(null);
            await safeJson(`${API_BASE}/user_profile_update.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(profile),
            });
            setToast({ type: "ok", msg: "Perfil actualizado." });
            await load();
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setSaving(false);
        }
    }

    async function uploadAvatar(file) {
        if (!file) return;
        try {
            setUploading("avatar");
            setToast(null);
            const fd = new FormData();
            fd.append("file", file);

            await safeJson(`${API_BASE}/user_avatar_upload.php`, {
                method: "POST",
                headers: authHeaders(),
                body: fd,
            });

            setToast({ type: "ok", msg: "Foto de usuario actualizada." });
            await load();
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setUploading("");
        }
    }

    const tabs = [
        ["general", "General"],
        ["brand", "Identidad visual"],
        ["user", "Usuario"],
        ["preview", "Vista previa"],
    ];

    return (
        <MainLayout>
            <Style />
            <div className="platform-settings-pro px-3 py-6 md:px-6 md:py-8"><div className="platform-settings-wrap">
                <div className="platform-hero">
                    <div>
                        <div><div className="platform-eyebrow">Administración</div><h2 className="platform-title">Configuración de Plataforma</h2>
                            <p className="platform-subtitle">
                                Logo, favicon, dominio, colores, datos comerciales y perfil de usuario.
                            </p>
                        </div></div>

                    <button
                        onClick={load}
                        className="platform-btn"
                    >
                        Recargar
                    </button>
                </div>

                {toast ? (
                    <div className={`rounded-xl px-4 py-3 text-xs ${toast.type === "ok" ? "platform-toast-ok" : "platform-toast-error"}`}>
                        {toast.msg}
                    </div>
                ) : null}

                <div className="platform-tabs">
                    {tabs.map(([key, label]) => (
                        <button
                            key={key}
                            onClick={() => setTab(key)}
                            className={`platform-tab ${tab === key ? "platform-tab-active" : ""}`}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                {loading ? <div className="platform-card rounded-[24px] p-5 text-sm text-[#9fc4df]">Cargando configuración...</div> : null}

                {!loading && tab === "general" ? (
                    <Card title="Datos generales" subtitle="Información visible de la plataforma y dominio.">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <Field label="Nombre de plataforma">
                                <input value={values.platform_name || ""} onChange={(e) => setValue("platform_name", e.target.value)} />
                            </Field>
                            <Field label="Nombre corto">
                                <input value={values.platform_short_name || ""} onChange={(e) => setValue("platform_short_name", e.target.value)} />
                            </Field>
                            <Field label="Nombre comercial">
                                <input value={values.commercial_name || ""} onChange={(e) => setValue("commercial_name", e.target.value)} />
                            </Field>
                            <Field label="Dominio actual">
                                <input value={values.domain || ""} onChange={(e) => setValue("domain", e.target.value)} />
                            </Field>
                            <Field label="Dominio público / comercial">
                                <input value={values.public_domain || ""} onChange={(e) => setValue("public_domain", e.target.value)} />
                            </Field>
                            <Field label="Correo soporte">
                                <input value={values.support_email || ""} onChange={(e) => setValue("support_email", e.target.value)} />
                            </Field>
                            <Field label="Teléfono soporte">
                                <input value={values.support_phone || ""} onChange={(e) => setValue("support_phone", e.target.value)} />
                            </Field>
                            <Field label="Descripción comercial">
                                <textarea rows={3} value={values.meta_description || ""} onChange={(e) => setValue("meta_description", e.target.value)} />
                            </Field>
                        </div>

                        <div className="flex justify-end mt-4">
                            <button disabled={saving} onClick={saveSettings} className="platform-btn platform-btn-primary disabled:opacity-60">
                                {saving ? "Guardando..." : "Guardar configuración"}
                            </button>
                        </div>
                    </Card>
                ) : null}

                {!loading && tab === "brand" ? (
                    <div className="space-y-4">
                        <Card title="Colores de plataforma" subtitle="Paleta institucional.">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                <Field label="Color primario">
                                    <input type="color" value={values.primary_color || "#1d4ed8"} onChange={(e) => setValue("primary_color", e.target.value)} />
                                </Field>
                                <Field label="Color secundario">
                                    <input type="color" value={values.secondary_color || "#0f172a"} onChange={(e) => setValue("secondary_color", e.target.value)} />
                                </Field>
                                <Field label="Color acento">
                                    <input type="color" value={values.accent_color || "#f59e0b"} onChange={(e) => setValue("accent_color", e.target.value)} />
                                </Field>
                            </div>
                            <div className="flex justify-end mt-4">
                                <button disabled={saving} onClick={saveSettings} className="platform-btn platform-btn-primary disabled:opacity-60">
                                    Guardar colores
                                </button>
                            </div>
                        </Card>

                        <Card title="Logos y archivos visuales" subtitle="Sube logo, favicon y recursos visuales.">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {[
                                    ["logo_path", "Logo principal"],
                                    ["logo_dark_path", "Logo fondo oscuro"],
                                    ["favicon_path", "Favicon"],
                                    ["login_background_path", "Fondo de login"],
                                ].map(([key, label]) => (
                                    <div key={key} className="platform-upload-box">
                                        <div className="font-semibold text-xs text-white">{label}</div>
                                        <div className="text-[10px] text-[#9fc4df] mt-1">{values[key] || "Sin archivo"}</div>
                                        {values[key] ? (
                                            <div className="mt-2">
                                                <img src={values[key]} alt={label} className="platform-upload-preview max-h-16 object-contain" />
                                            </div>
                                        ) : null}
                                        <input
                                            className="mt-3 text-xs"
                                            type="file"
                                            accept="image/png,image/jpeg,image/webp,image/svg+xml,image/x-icon"
                                            onChange={(e) => uploadAsset(key, e.target.files?.[0])}
                                        />
                                        {uploading === key ? <div className="text-[10px] text-[#9fc4df] mt-1">Subiendo...</div> : null}
                                    </div>
                                ))}
                            </div>
                        </Card>
                    </div>
                ) : null}

                {!loading && tab === "user" ? (
                    <Card title="Perfil de usuario" subtitle="Foto y datos visibles en PM, CRM e Institución.">
                        <div className="grid grid-cols-1 lg:grid-cols-[180px_1fr] gap-4">
                            <div className="platform-avatar-box">
                                {profile.avatar_path ? (
                                    <img src={profile.avatar_path} alt="Avatar" className="platform-avatar w-24 h-24 rounded-full object-cover mx-auto" />
                                ) : (
                                    <div className="platform-avatar w-24 h-24 rounded-full bg-[#d4af37] text-[#081a2b] mx-auto grid place-items-center text-2xl font-semibold">
                                        {profile.iniciales || "U"}
                                    </div>
                                )}

                                <input
                                    className="mt-3 text-xs w-full"
                                    type="file"
                                    accept="image/png,image/jpeg,image/webp"
                                    onChange={(e) => uploadAvatar(e.target.files?.[0])}
                                />
                                {uploading === "avatar" ? <div className="text-[10px] text-[#9fc4df] mt-1">Subiendo...</div> : null}
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Field label="Nombre visible">
                                    <input value={profile.display_name || profile.name || profile.full_name || ""} onChange={(e) => setProfile({ ...profile, display_name: e.target.value, name: e.target.value, full_name: e.target.value })} />
                                </Field>
                                <Field label="Iniciales">
                                    <input value={profile.iniciales || ""} onChange={(e) => setProfile({ ...profile, iniciales: e.target.value })} />
                                </Field>
                                <Field label="Teléfono">
                                    <input value={profile.phone || ""} onChange={(e) => setProfile({ ...profile, phone: e.target.value })} />
                                </Field>
                                <Field label="Puesto / cargo">
                                    <input value={profile.position || profile.job_title || ""} onChange={(e) => setProfile({ ...profile, position: e.target.value, job_title: e.target.value })} />
                                </Field>
                                <Field label="Correo">
                                    <input value={profile.email || ""} disabled />
                                </Field>
                                <Field label="Rol">
                                    <input value={profile.role || ""} disabled />
                                </Field>
                            </div>
                        </div>

                        <div className="flex justify-end mt-4">
                            <button disabled={saving} onClick={saveProfile} className="platform-btn platform-btn-primary disabled:opacity-60">
                                {saving ? "Guardando..." : "Guardar perfil"}
                            </button>
                        </div>
                    </Card>
                ) : null}

                {!loading && tab === "preview" ? (
                    <Card title="Vista previa" subtitle="Lectura rápida de identidad configurada.">
                        <div className="platform-preview rounded-2xl p-5" style={{ "--preview-color": values.primary_color || "#d4af37" }}>
                            <div className="flex items-center gap-4">
                                {values.logo_path ? (
                                    <img src={values.logo_path} alt="Logo" className="h-14 object-contain" />
                                ) : (
                                    <div className="h-14 w-14 rounded-xl bg-[#d4af37] text-[#081a2b] grid place-items-center font-semibold">
                                        {values.platform_short_name || "PM"}
                                    </div>
                                )}
                                <div>
                                    <div className="text-xl font-semibold text-white">{values.platform_name || "Plataforma"}</div>
                                    <div className="text-sm text-[#9fc4df]">{values.commercial_name || "Producto comercial"}</div>
                                    <div className="text-xs text-[#8fb9da]">{values.public_domain || values.domain || "Dominio pendiente"}</div>
                                </div>
                            </div>
                            <p className="text-sm text-[#d7e8f6] mt-4">{values.meta_description}</p>
                        </div>
                    </Card>
                ) : null}
            </div>
            </div>
        </MainLayout>
    );
}
